import {
  CARROSSEL_LIST,
  CARROSSEL_GET,
  CARROSSEL_CREATE,
  CARROSSEL_DELETE,
  CARROSSEL_UPDATE,
  CARROSSEL_UPDATE_IMAGE,
  CARROSSEL_DELETE_SLIDE,
  CARROSSEL_DUPLICATE
} from "../actions/carrossel";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const buildListParams = (filters = {}) => {
  const params = {
    tipo_conteudo: filters.tipoConteudo,
    limit: filters.limit ?? 20,
    offset: filters.offset ?? 0
  };

  if (filters.titulo) {
    params.titulo = filters.titulo;
  }
  if (filters.ativo === true || filters.ativo === false) {
    params.ativo = filters.ativo;
  }
  if (filters.local) {
    params.local = filters.local;
  }
  if (filters.periodoInicio) {
    params.periodo_inicio = filters.periodoInicio;
  }
  if (filters.periodoFim) {
    params.periodo_fim = filters.periodoFim;
  }

  return params;
};

const actions = {
  [CARROSSEL_LIST]: ({ dispatch, getters }, payload) => {
    const filters =
      payload && typeof payload === "object" && !Array.isArray(payload)
        ? payload
        : { tipoConteudo: payload };

    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .listCarrossel(getters.getFornecedorId, buildListParams(filters))
        .then(resp => {
          resolve({
            data: resp.data?.data || [],
            total: resp.data?.total ?? 0
          });
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_GET]: ({ dispatch }, idcarrossel) => {
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .getCarrossel(idcarrossel)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .createCarrossel(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_DELETE]: ({ dispatch, getters }, idcarrossel) => {
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .deleteCarrossel(getters.getFornecedorId, idcarrossel)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_UPDATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .updateCarrossel(payload.idcarrossel, payload.configs)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_UPDATE_IMAGE]: ({ dispatch, getters }, payload) => {
    const { idcarrossel, idslide, formData } = payload;
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .updateImage(getters.getFornecedorId, idcarrossel, idslide, formData)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_DELETE_SLIDE]: ({ dispatch, getters }, payload) => {
    const { idcarrossel, idslide } = payload;
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .deleteSlide(getters.getFornecedorId, idcarrossel, idslide)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [CARROSSEL_DUPLICATE]: ({ dispatch, getters }, idcarrossel) => {
    return new Promise((resolve, reject) => {
      Api.v4.carrossel
        .duplicateCarrossel(getters.getFornecedorId, idcarrossel)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
